import { Box, Flex, PrimaryButton, Stack } from "flicket-ui";
import { ReactNode } from "react";
import { ExpressCheckoutSection } from "./ExpressCheckoutSection";

interface FooterActionBarProps {
  priceInfo: ReactNode;
  buttonText: string;
  onAction: () => void;
  isLoading: boolean;
  isDisabled: boolean;
}

export const FooterActionBar = ({
  priceInfo,
  buttonText,
  onAction,
  isLoading,
  isDisabled,
}: FooterActionBarProps) => {
  return (
    <Flex width="100%" alignItems="center" justifyContent="space-between">
      <Box>{priceInfo}</Box>

      <Stack
        width={{ sm: "auto", base: "50%" }}
        maxWidth={"50%"}
        flexDirection={{ sm: "row", base: "column" }}
        gap={2}
        justifyContent="flex-end"
        alignItems="center"
      >
        <ExpressCheckoutSection />

        <PrimaryButton
          minW={234}
          width={{ _: "100%", sm: "50%" }}
          onClick={() => void onAction()}
          isLoading={isLoading}
          disabled={isDisabled}
        >
          {buttonText}
        </PrimaryButton>
      </Stack>
    </Flex>
  );
};
